<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
    </v-snackbar>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-row>
            <v-col cols="12" md="3" class="ml-3">
              <v-btn
                color="#7BC243"
                to="/grnfile"
                class="white--text cataloguebtn"
                >View All Files
              </v-btn>
            </v-col>
            <v-spacer> </v-spacer>
          </v-row>
          <v-card-title>
            <v-row>
              <v-col cols="12" md="4">
                <v-btn
                  @click="approveRecords"
                  v-if="selected.length > 0 && countSelectedItems > 0"
                  color="primary"
                  >Approve</v-btn
                >
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="records"
              item-key="id"
              class="elevation-1"
              :search="search"
              :single-select="singleSelect"
            >
              <template
                v-slot:[`item.data-table-select`]="{ isSelected, select, item }"
              >

                <v-simple-checkbox
                  :ripple="false"
                  color="green"
                  :value="isSelected"
                  @input="select($event)"
                  v-if="
                    item.status.statusName === 'HOLDING_STATUS' ||
                    item.status.statusName === 'PENDING-APPROVAL' ||
                    item.status.statusName === 'COLLECTED' ||
                    item.status.statusName === 'PENDING-PAYMENT' ||
                    item.status.statusName == 'PAID' ||
                    !$can('CAN_APPROVE_GRN')
                  "
                  disabled
                  class="d-none"
                ></v-simple-checkbox>
                <v-simple-checkbox
                  :ripple="false"
                  color="green"
                  :value="isSelected"
                  @input="select($event)"
                  v-else
                ></v-simple-checkbox>
              </template>
              <!-- <template v-slot:[`item.dateUpdated`]="{ item }">
      {{ item.dateUpdated | prettyDate }} -->
    <!-- </template> -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      class="actions"
                    >
                      <v-icon class="secondary--text"> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="canUploadGrn && item.status.id == 25">
                    <v-list-item>
                      <v-btn @click="editItem(item)"> Edit</v-btn>
                    </v-list-item>
                  </v-list>
                  <v-list v-if="canApproveGrn && canBeApproved(item)">
                    <v-list-item>
                      <v-btn @click="approveParchment(item)"> Approve</v-btn>
                    </v-list-item>
                  </v-list>
                  <!--        <v-list>-->
                  <!--          <v-list-item v-if="$can('CAN_APPROVE_GRN') && (item.status.statusName != 'HOLDING_STATUS' && item.status.statusName != 'PENDING-PAYMENT' && item.status.statusName !='PAID' && item.status.statusName != 'COLLECTED')" @click="showEditDialog(item)">-->
                  <!--            <v-list-item-title> Edit </v-list-item-title>-->
                  <!--          </v-list-item>-->
                  <!--        </v-list>-->
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="editDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit GRN Record</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.outTurnNumber"
                  :rules="outturnNumberRules"
                  label="OutturnNumber"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.bags"
                  label="Bags"
                  required
                  readonly
                  disabled
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.pockets"
                  :rules="pocketRules"
                  label="Pockets"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.grossWeight"
                  label="Gross W"
                  required
                  readonly
                  disabled
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.tareWeight"
                  label="Tare W"
                  required
                  readonly
                  disabled
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.netWeight"
                  label="Net W"
                  required
                  readonly
                  disabled
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.season"
                  :rules="seasonRules"
                  label="Season"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editedItem.saleNumber"
                  :rules="saleNumberRules"
                  label="Sale Number"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  name="millerCode"
                  v-model="editedItem.millerCode"
                  :items="millers"
                  :rules="millerRules"
                  item-text="name"
                  item-value="millerCode"
                  label="Miller"
                  v-validate="'required'"
                >
                  >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  name="warehouseCode"
                  v-model="editedItem.warehouseCode.organisationCode"
                  :items="warehouse"
                  :rules="warehouseRules"
                  item-text="name"
                  item-value="warehouseCode"
                  label="Warehouse"
                  v-validate="'required'"
                >
                  >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete
                  name="brokerCode"
                  v-model="editedItem.brokerCode.organisationCode"
                  :items="brokers"
                  :rules="brokerRules"
                  item-text="name"
                  item-value="brokerCode"
                  label="Broker"
                  v-validate="'required'"
                >
                  >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  v-model="editedItem.actionComment"
                  :rules="actionCommentRules"
                  label="Comment"
                  required
                >
                </v-textarea>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="editedItem.deleteFlag"
                  label="Delete"
                  @change="handleChange"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn color="secondary"
                class="accent--text logoutbtn" @click.native="close">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#7BC243" @click.native="update">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "../../../store";
import config from "../../../config";
import axios from "axios";

export default {
  name: "grnfiledetails",
  data: function () {
    return {
      headers: [
        { text: "OutTurn", value: "outTurnNumber" },
        { text: "Grade", value: "grade" },
        { text: "Marks", value: "marks" },
        { text: "Bags", value: "bags" },
        { text: "Pockets", value: "pockets" },
        { text: "Season", value: "season" },
        { text: "Sale Number", value: "saleNumber" },
        { text: "Miller", value: "millerCode" },
        { text: "Gross W", value: "grossWeight" },
        { text: "Tare W", value: "tareWeight" },
        { text: "Net W", value: "netWeight" },
        { text: "Comments", value: "actionComment" },
        { text: "Updated By", value: "updatedBy" },
        // { text: "Date", value: "dateUpdated" },
        { text: "Status", value: "status.statusName" },
        // { text: "Actions", value: "actions" },
      ],
      selected: [],
      message: "",
      loading: false,
      snackbar: false,
      snackbarColor: "",
      search: "",
      singleSelect: false,
      grnRecord: {},
      editDialog: false,
      valid: true,
      permissions: [],
      items: [],
      editedIndex: -1,
      millers: [],
      warehouse: [],
      brokers: [],
      editedItem: {
        id: "",
        outTurnNumber: "",
        grade: "",
        marks: "",
        bags: "",
        pockets: "",
        season: "",
        saleNumber: "",
        millerCode: "",
        warehouseCode: [],
        brokerCode: [],
        grossWeight: "",
        tareWeight: "",
        netWeight: "",
        status: "",
        deleteFlag: "",
      },
      defaultItem: {
        id: "",
        outTurnNumber: "",
        grade: "",
        marks: "",
        bags: "",
        pockets: "",
        season: "",
        saleNumber: "",
        millerCode: "",
        warehouseCode: [],
        brokerCode: [],
        grossWeight: "",
        tareWeight: "",
        netWeight: "",
        status: "",
        deleteFlag: "",
      },
      editedItem: {
        id: "",
        outTurnNumber: "",
        grade: "",
        marks: "",
        bags: "",
        pockets: "",
        season: "",
        saleNumber: "",
        millerCode: "",
        warehouseCode: [],
        brokerCode: [],
        grossWeight: "",
        tareWeight: "",
        netWeight: "",
        status: "",
        actionComment: "",
        deleteFlag: "",
      },
      outturnNumberRules: [(v) => !!v || "OutturnNumber is required"],
      seasonRules: [(v) => !!v || "Season is required"],
      pocketRules: [(v) => !!v || "Pocket is required"],
      saleNumberRules: [(v) => !!v || "SaleNumber  is required"],
      millerRules: [(v) => !!v || "Miller  is required"],
      actionCommentRules: [(v) => !!v || "Comment  is required"],
      warehouseRules: [(v) => !!v || "Warehouse  is required"],
      brokerRules: [(v) => !!v || "broker  is required"],
    };
  },
  watch: {},
  mounted() {
    this.permissions = store.state.user.roleId.permissions;
    // this.getMillers();
    // this.getWarehouse();
    // this.getBrokers();
  },
  computed: {
    ...mapState({
      records: (state) => state.grnfile.records,
    }),
    countSelectedItems() {
      // eslint-disable-next-line no-undef
      return (
        this.records.filter(
          (item) => item.status.statusName !== "HOLDING_STATUS"
        ).length ||
        item.status.statusName !== "PAID" ||
        item.status.statusName !== "COLLECTED"
      );
    },
    canUploadGrn: function () {
      return this.hasPerm("CAN_UPLOAD_GRN");
    },
    canApproveGrn: function () {
      return this.hasPerm("CAN_APPROVE_GRN");
    },
  },
  methods: {
    ...mapActions({
      warehouseApproveRecords: "grnfile/warehouseApproveRecords",
      editRecord: "grnfile/editRecord",
    }),
    showEditDialog(item) {
      this.grnRecord = item;
      this.editDialog = true;
    },
    approveParchment(item) {
      var url = config.serverURI + "/grn_record/approve-item";
      console.log(item);
      axios
        .post(url, item)
        .then((response) => {
          this.message = response.data.message;
          if (response.data.error) {
            this.snackbarColor = "error";
          } else {
            this.snackbarColor = "primary";
            this.$store.dispatch("grnfile/viewFile", this.$route.params.id);
            // this.getCleanDetails();
          }
          this.snackbar = true;
        })
        .catch((error) => {
          // Request failed.
          console.log("error", error.response);
          this.snackbarColor = "error";
          this.snackbar = true;
        });
    },
    approveRecords() {
      this.warehouseApproveRecords(this.selected)
        .then((response) => {
          if (response.data.error === false) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }
          this.$store.dispatch("grnfile/viewFile", this.$route.params.id);
          this.selected = [];
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
    },
    triggerEditRecord() {
      this.editRecord(this.grnRecord)
        .then((response) => {
          if (response.data.error === false) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }
          this.$store.dispatch("grnfile/viewFile", this.$route.params.id);
          this.selected = [];
          this.editDialog = false;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
          this.editDialog = false;
        });
    },
    canBeApproved(item) {
      return item.status.id === 3;
    },
    editItem(item) {
      this.editedIndex = this.records.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
    },
    handleChange() {
      // Update deleteFlag to true if the checkbox is checked
      this.editedItem.deleteFlag = true;
    },
    hasPerm(permission) {
      return this.permissions.includes(permission);
    },
    getMillers: function () {
      const url = config.serverURI + "/organization/getMillers";
      axios
        .post(url)
        .then((response) => {
          this.millers = response.data;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
      return this.organisations;
    },
    getWarehouse: function () {
      const url = config.serverURI + "/organization/getWarehouse";
      axios
        .post(url)
        .then((response) => {
          this.warehouse = response.data;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
      return this.organisations;
    },
    getBrokers: function () {
      const url = config.serverURI + "/organization/getBrokers";
      axios
        .post(url)
        .then((response) => {
          this.brokers = response.data;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
        });
      return this.organisations;
    },
    update() {
      if (this.$refs.form.validate()) {
        var url = config.serverURI + "/grn_record/update";
        console.log(this.editedItem);
        axios
          .post(url, this.editedItem)
          .then((response) => {
            this.message = response.data.message;
            if (response.data.error) {
              this.snackbarColor = "error";
            } else {
              this.snackbarColor = "primary";
              this.$store.dispatch("grnfile/viewFile", this.$route.params.id);
            }
            this.snackbar = true;
            this.close();
          })
          .catch((error) => {
            // Request failed.
            console.log("error", error.response);
            this.snackbarColor = "error";
            this.snackbar = true;
            this.close();
          });
      }
    },
    close() {
      this.editDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
  created() {
    this.$store.dispatch("grnfile/viewDeletedFile", this.$route.params.id);
  },
};
</script>
<style></style>
